module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/buying-small-cef321a3b569cb1ec1c7aa182d5a4e37.svg";